// import { MockAppointmentManager } from "@/mock/MockAppointmentManager";
// import {
//   IAppointmentManager,
//   TokenIAppointmentManager,
// } from "@/out-look/interfaces";
import { IOutlookAppointmentService, OutlookAppointmentService, TokenIOutlookAppointmentService } from "@/out-look/services";
import { IOrganizationService, IResourceService, OrganizationService, ResourceService, TokenIOrganizationService, TokenIResourceService } from "@/services";
import { AttendeeService } from "@/services/attendee-service/AttendeeService";
import { IAttendeeService, TokenIAttendeeService } from "@/services/attendee-service/IAttendeeService";
import { BookingService, IBookingService, TokenIBookingService } from "@/services/booking-service";
import { IOrderService, OrderService, TokenIOrderService } from "@/services/order-service";
import { IRcResourceService, RcResourceService, TokenIRcResourceService } from "@/services/rc-resource-service";
import { DependencyContainer, Lifecycle, container as defaultContainer } from "tsyringe";

let baContainer: DependencyContainer = defaultContainer;
export { baContainer };

export const RegisterRFServices = (container: DependencyContainer) => {
  //Service addin
  container.register<IBookingService>(TokenIBookingService, { useClass: BookingService }, { lifecycle: Lifecycle.Singleton });
  container.register<IOrganizationService>(TokenIOrganizationService, { useClass: OrganizationService }, { lifecycle: Lifecycle.Singleton });
  container.register<IResourceService>(TokenIResourceService, { useClass: ResourceService }, { lifecycle: Lifecycle.Singleton });
  container.register<IAttendeeService>(TokenIAttendeeService, { useClass: AttendeeService }, { lifecycle: Lifecycle.Singleton });
  container.register<IOutlookAppointmentService>(TokenIOutlookAppointmentService, { useClass: OutlookAppointmentService }, { lifecycle: Lifecycle.Singleton });
  container.register<IOrderService>(TokenIOrderService, { useClass: OrderService }, { lifecycle: Lifecycle.Singleton });
  container.register<IRcResourceService>(TokenIRcResourceService, { useClass: RcResourceService }, { lifecycle: Lifecycle.Singleton });

  // if (import.meta.env.VITE_APP_ENV === "development") {
  //   container.register<IAppointmentManager>(
  //     TokenIAppointmentManager,
  //     { useClass: MockAppointmentManager },
  //     { lifecycle: Lifecycle.Singleton }
  //   );
  // }

  baContainer = container;
};
